// extracted by mini-css-extract-plugin
export default {"today":"Events_today__Bn+Ka"};